import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
} from "./Word";

// 🧠 共通ロジック：Reduxアクセス + パラメータ処理
const useTextFieldValue = (
  storeKey,
  actionType,
  key,
  buldingParam,
  pageParam
) => {
  const params = useParams();
  const bulding = buldingParam || params.b;
  const page = pageParam || params.page;
  const dispatch = useDispatch();

  const rawValue = useSelector(
    (state) => state[storeKey]?.[bulding]?.[page]?.[key]
  );
  const value = rawValue ?? "";

  const change = (val) => {
    dispatch({
      type: actionType,
      payload: { [key]: val },
      bulding,
      page,
    });
  };

  return { value, change };
};

// ✨ 共通コンポーネント
const BaseTextField = ({
  storeKey,
  actionType,
  key_num,
  label = "",
  placeholder = "複数行入力可能箇所", // ←✨追加
  bulding,
  page,
  multiline = false,
}) => {
  const { value, change } = useTextFieldValue(
    storeKey,
    actionType,
    key_num,
    bulding,
    page
  );

  return (
    <TextField
      fullWidth
      variant="filled"
      value={value}
      multiline={multiline}
      onChange={(e) => change(e.target.value)}
      label={label}
      placeholder={multiline ? placeholder : ""} // ←✨multiline時だけ表示
    />
  );
};

// 🌸 各エクスポート：用途に応じてパラメータ指定するだけ！

export const InputTextField = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
  />
));

export const InputTextFieldMulti = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
    multiline
  />
));

export const InputTextFieldEquip = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
  />
));

export const InputTextFieldMultiEquip = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
    multiline
  />
));

export const InputTextFieldFireEquip = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
  />
));

export const InputTextFieldMultiFireEquip = React.memo((props) => (
  <BaseTextField
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
    multiline
  />
));
